var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ag-grid-vue',{staticClass:"ag-theme-balham",staticStyle:{"height":"200px"},attrs:{"grid-options":_vm.gridOptions,"animate-rows":true,"modules":_vm.modules,"row-data":_vm.stock},on:{"cellValueChanged":_vm.cellValueChanged,"grid-ready":_vm.onGridReady}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }